import React, {useEffect} from 'react';
import ScrollTop from '../components/ScrollTop';

import ProductsSection from '../components/ProductsSection';

const ProductsPage = () => {
    return(
        <div>
            <ProductsSection />
            <ScrollTop/>
        </div>
    )
}

export default ProductsPage;